import authenticationTypes from './types';
import { getLocalAuth } from 'Helpers';

export const initialStates = {
	auth: {
		masterToken: null,
		activeBusinessToken: null,
	},
	user: null,
	isAuthenticated: false,
	isAppInitializing: false,
	sessions: null,
	otpToken: null,
	uuid: null,
	businessList: [],
};

const authenticationReducers = (state = initialStates, action) => {
	switch (action.type) {
		case authenticationTypes.LOGIN_BY_OTP.SUCCESS:
			return { ...state, otpToken: action.payload.otp_token };
		case authenticationTypes.LOGIN_BY_OTP.FAILURE:
			return { ...state };

		case authenticationTypes.LOGIN.SUCCESS:
			return {
				...state,
				isAuthenticated: true,
				isAppInitializing: false,
				auth: {
					masterToken: action.payload.token,
					activeBusinessToken: action.payload.token,
				},
				user: action.payload.user,
				uuid: action.payload.uuid,
				businessList: action.payload.businessList,
				otpToken: null,
			};
		case authenticationTypes.LOGIN.FAILURE:
			return { ...state, isAppInitializing: false };

		case authenticationTypes.LOGIN_BY_ID.SUCCESS:
			return {
				...state,
				isAuthenticated: true,
				auth: action.payload.auth,
				user: action.payload.user,
				uuid: action.payload.uuid,
			};

		case authenticationTypes.GET_SESSIONS.SUCCESS:
			return { ...state, sessions: action.payload };
		case authenticationTypes.GET_SESSIONS.FAILURE:
			return { ...state };

		case authenticationTypes.APP_INIT.REQUEST:
			return { ...state, isAppInitializing: true };

		case authenticationTypes.LOGOUT.SUCCESS:
			return initialStates;

		case authenticationTypes.APP_INIT.SUCCESS: {
			const { auth } = getLocalAuth() || {};
			return {
				...state,
				auth,
				isAuthenticated: true,
				isAppInitializing: false,
				user: action.payload,
			};
		}

		default:
			return state;
	}
};

export default authenticationReducers;
